import { Component } from '@angular/core';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';

// Angular modules
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

import { LanguageService } from '../../../services/language/language.service';
import { ConstantStrings } from '../../../constants/constant-strings';

@Component({
  selector: 'app-cookies.popup',
  standalone: true,
  imports: [
    // Angular modules
    CommonModule,
    MatDialogModule,
    MatButtonModule,
  ],
  templateUrl: './cookies.popup.component.html',
  styleUrl: './cookies.popup.component.css'
})
export class CookiesPopupComponent {


  markdownFiles:any = ConstantStrings.markdownFiles


  constructor(
    public languageService:LanguageService,
    public dialogRef: MatDialogRef<CookiesPopupComponent>,
  ){
    
  }




  // ----- Button actions ----- //

  acceptButtonClicked(){
    this.dialogRef.close(true)
  }

  rejectButtonClicked(){
    this.dialogRef.close(false)
  }


  openMarkdownFile(targetFile:string){
    let signed:string = 'false'
    if(targetFile == this.markdownFiles.informationSecurityPolicy) signed = 'true'
    window.open(`/markdown-viewer?file=${targetFile}&signed=${signed}`, '_self');
  }


  

}
